"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FallbackRedirectHandler = void 0;
const SessionInfoManager_1 = require("../../../sessionInfo/SessionInfoManager");
class FallbackRedirectHandler {
    async canHandle(redirectUrl) {
        try {
            new URL(redirectUrl);
            return true;
        }
        catch (e) {
            throw new Error(`[${redirectUrl}] is not a valid URL, and cannot be used as a redirect URL: ${e.toString()}`);
        }
    }
    async handle(_redirectUrl) {
        return SessionInfoManager_1.getUnauthenticatedSession();
    }
}
exports.FallbackRedirectHandler = FallbackRedirectHandler;
//# sourceMappingURL=FallbackRedirectHandler.js.map